"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionComponents = exports.SubscriptionComponent = void 0;
var react_1 = require("react");
var lodash_1 = require("lodash");
var hooks_1 = require("../hooks");
var SubscriptionComponent = function (_a) {
    var variables = _a.variables, config = _a.config;
    hooks_1.useSubscription({
        variables: variables,
        config: config,
    });
    return null;
};
exports.SubscriptionComponent = SubscriptionComponent;
var SubscriptionComponents = function (_a) {
    var subscriptionVarsList = _a.subscriptionVarsList, getKeyFromProps = _a.getKeyFromProps, config = _a.config;
    return react_1.createElement(react_1.Fragment, {}, lodash_1.map(subscriptionVarsList, function (variables, key) {
        return react_1.createElement(exports.SubscriptionComponent, {
            key: (getKeyFromProps === null || getKeyFromProps === void 0 ? void 0 : getKeyFromProps(variables)) || key,
            config: config,
            variables: variables,
        });
    }));
};
exports.SubscriptionComponents = SubscriptionComponents;
//# sourceMappingURL=SubscriptionComponents.js.map